import React from "react";
import { styled } from "@mui/system";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import Popper from "@vapor/react-material/Popper";

export const StyledAutocompletePopperFreeText = styled(
  (props) => (
    <Popper
      {...props}
      open={true}
      modifiers={[
        {
          name: "flip",
          enabled: false,
          options: {
            altBoundary: true,
            rootBoundary: "document",
            padding: 8
          }
        }
      ]}
    />
  ),

  {
    name: "StyledAutocompletePopperFreeText",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "width",
    overridesResolver: (props, styles) => []
  }
)<{ width?: any }>(({ theme, width }) => ({
  width: "fit-content",
  [`& .${autocompleteClasses.paper}`]: {
    boxShadow: "none",
    margin: "0px",
    color: "inherit",
    borderRadius: 0,
    width: width ? width : "100%",
    // ...sx,
    marginLeft: "1px",
    marginTop: "10px",
    maxHeight: "444px"
    //border: "1px solid black",
  },
  [`& .${autocompleteClasses.listbox}`]: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.surfaceDefault,
    paddingTop: "8px",
    paddingBottom: "8px",
    width: width ? width : "100%",
    overflowX: "hidden",
    // ...sx,
    // height: "120px",
    maxHeight: "290px",
    [`& .${autocompleteClasses.option}`]: {
      ...theme.typography["body"],
      minHeight: "auto",
      alignItems: "flex-start",
      padding: "10px 16px",
      width: width ? width : "100%",
      '&[aria-selected="true"]': {
        backgroundColor: "transparent",
        "& .MuiTypography-root": {
          color: "#21282B"
        }
      },
      '&[data-focus="true"], &[data-focus="true"][aria-selected="true"]': {
        backgroundColor: theme.palette.action.hover
      }
    }
  },
  [`& .${autocompleteClasses.popperDisablePortal}`]: {
    position: "relative"
  }
}));
